import { DockviewApi } from 'dockview';

export const DOCKVIEW_LAYOUT_KEY = 'dockview_layout_v1';
export const TAB_COUNTER_KEY = 'dockview_tab_counter_v1';

export const saveDockviewLayout = (api: DockviewApi, forceEvenIfEmpty = false) => {
  try {
    const panels = Array.from(api.panels.values());
    if (panels.length === 0 && !forceEvenIfEmpty) {
      return;
    }
    const layout = api.toJSON();
    localStorage.setItem(DOCKVIEW_LAYOUT_KEY, JSON.stringify(layout));
  } catch (error) {
    console.warn('Failed to save dockview layout:', error);
  }
};

export const loadDockviewLayout = (): any | null => {
  try {
    const stored = localStorage.getItem(DOCKVIEW_LAYOUT_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch (error) {
    console.warn('Failed to load dockview layout:', error);
    return null;
  }
};

export const saveTabCounter = (counter: number) => {
  try {
    localStorage.setItem(TAB_COUNTER_KEY, counter.toString());
  } catch (error) {
    console.warn('Failed to save tab counter:', error);
  }
};

export const loadTabCounter = (): number => {
  try {
    const stored = localStorage.getItem(TAB_COUNTER_KEY);
    return stored ? parseInt(stored, 10) : 0;
  } catch (error) {
    console.warn('Failed to load tab counter:', error);
    return 0;
  }
};

export const clearDockviewLayout = () => {
  localStorage.removeItem(DOCKVIEW_LAYOUT_KEY);
};
